import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState, lazy, Suspense } from "react";
import { AuthProvider } from "./context/AuthContext";
import { SearchProvider } from "./context/SearchContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { CartProvider } from "./context/CartContext";

// Composants toujours chargés (présents sur toutes les pages)
import Header from './components/Header';
import Footer from "./components/Footer";
import CartWidget from "./components/CartWidget";

// Pages chargées uniquement si la route est visitée (code splitting)
const HomePage             = lazy(() => import('./pages/HomePage'));
const ProductPage          = lazy(() => import('./pages/ProductPage'));
const Login                = lazy(() => import('./pages/Login'));
const Register             = lazy(() => import('./pages/Register'));
const AdminPage            = lazy(() => import('./pages/AdminPage'));
const AdminProductStatus   = lazy(() => import('./pages/AdminProductStatus'));
const UpdateProduct        = lazy(() => import('./pages/UpdateProduct'));
const AddProduct           = lazy(() => import('./pages/AddProduct'));
const Users                = lazy(() => import('./pages/Users'));
const UserUpdate           = lazy(() => import('./pages/UserUpdate'));
const CategoryProduct      = lazy(() => import('./pages/CategoryProduct'));
const AddComment           = lazy(() => import('./pages/AddComment'));
const UpdateComment        = lazy(() => import('./pages/UpdateComment'));
const UserComment          = lazy(() => import('./pages/UserComment'));
const SubCategoryProduct   = lazy(() => import('./pages/SubCategoryProduct'));
const FormEmail            = lazy(() => import('./pages/FormEmail'));
const Landing              = lazy(() => import('./pages/Landing'));
const StockManager         = lazy(() => import('./pages/StockManager'));
const Cart                 = lazy(() => import('./pages/Cart'));
const Livraison            = lazy(() => import('./pages/Livraison'));
const Payment              = lazy(() => import('./pages/Payment'));
const ShippingFeesManage   = lazy(() => import('./pages/ShippingFeesManage'));
const ShippingFeeUpdate    = lazy(() => import('./pages/ShippingFeeUpdate'));
const ShippingFeeAdd       = lazy(() => import('./pages/ShippingFeeAdd'));
const AdressePage          = lazy(() => import('./pages/AdressePage'));
const ProfilePage          = lazy(() => import('./pages/ProfilePage'));
const AddCardForm          = lazy(() => import('./pages/AddCardForm'));
const CardList             = lazy(() => import('./pages/CardList'));
const AdminSale            = lazy(() => import('./pages/AdminSale'));
const AddSale              = lazy(() => import('./pages/AddSale'));
const UpdateSale           = lazy(() => import('./pages/UpdateSale'));
const Sales                = lazy(() => import('./pages/Sales'));
const AdminOrder           = lazy(() => import('./pages/AdminOrder'));
const ConfirmationPayment  = lazy(() => import('./pages/ConfirmationPayment'));

const stripePromise = loadStripe("pk_test_51Ryss5B2XxfdJHf6O0QxHMX2wyzmtWoJDf5Sm6r1EiZgulUzTIqqGyXFwgSelydE0w8ap2Mztr8uDehD8bzO9RP4007UKFnDln")


function App() {
  const [cartItems, setCartItems] = useState([]);

  return (
    <ThemeProvider>
    <AuthProvider>
      <SearchProvider>
        <Elements stripe={stripePromise}>
          <CartProvider>
            <Router>
              <Header />
              <CartWidget cartItems={cartItems} setCartItems={setCartItems} />

              {/* Suspense affiche un fallback minimal pendant le chargement du chunk */}
              <Suspense fallback={<div className="page-loading"></div>}>
                <Routes>
                  <Route path="/" element={<Landing />} />
                  <Route path="/sales" element={<Sales/>} />
                  <Route path="/:gender" element={<HomePage/>} />
                  <Route path="/:gender/:Category" element={<CategoryProduct/>} />
                  <Route path="/:gender/:Category/:subcategory" element={<SubCategoryProduct />} />
                  <Route path="/product/:id" element={<ProductPage cartItems={cartItems} setCartItems={setCartItems} />} />
                  <Route path="/login" element={<Login/>} />
                  <Route path="/register" element={<Register/>} />
                  <Route path="/cart" element={<Cart cartItems={cartItems} setCartItems={setCartItems} />} />
                  <Route path="/livraison" element={<Livraison />} />
                  <Route path="/payment" element={<Payment />} />
                  <Route path="/admin" element={<AdminPage/>} />
                  <Route path="/admin/status" element={<AdminProductStatus/>} />
                  <Route path="/admin/status/updateProduct/:id" element={<UpdateProduct/>} />
                  <Route path="/admin/addProduct" element={<AddProduct/>} />
                  <Route path="/admin/users" element={<Users/>} />
                  <Route path="/admin/user/update/:id" element={<UserUpdate/>} />
                  <Route path="/admin/user/update/comment/:id" element={<UserComment/>} />
                  <Route path="/admin/ShippingFees" element={<ShippingFeesManage/>} />
                  <Route path="/admin/ShippingFee/:id" element={<ShippingFeeUpdate/>} />
                  <Route path="/admin/ShippingFee/add" element={<ShippingFeeAdd/>} />
                  <Route path="/admin/sale" element={<AdminSale/>} />
                  <Route path="/admin/sale/add/:id" element={<AddSale/>} />
                  <Route path="/admin/sale/update/:id" element={<UpdateSale/>} />
                  <Route path="/admin/order" element={<AdminOrder/>} />
                  <Route path='/adresses' element={<AdressePage/>} />
                  <Route path="/addComment/:id" element={<AddComment/>} />
                  <Route path="/updateComment/:id" element={<UpdateComment/>} />
                  <Route path="/formEmail" element={<FormEmail/>} />
                  <Route path="/admin/StockManager" element={<StockManager/>} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/cards" element={<AddCardForm />} />
                  <Route path="/cards-list" element={<CardList />} />
                  <Route path="/confirmation" element={<ConfirmationPayment />} />
                </Routes>
              </Suspense>

            <Footer />
          </Router>
         </CartProvider>
        </Elements>
      </SearchProvider>
    </AuthProvider>
    </ThemeProvider>
  )
}

export default App;
